// Presets of mock data for development and testing
// Each preset contains users, files, permissions, etc.

export type MockUser = {
  id: string;
  name: string;
  permissions: string[];
};

export type MockDicomFile = {
  id: string;
  name: string;
  size: number;
  uploadedBy: string; // user id
};

// New type for extended user format
export type MockUserFull = {
  id: string;
  user_name: string;
  full_name: string;
  email: string;
  user_roles: unknown[];
  user_sites: unknown[];
  studies: unknown[];
  user_settings: unknown[];
};

// Options for currentUser for tests
export const mockCurrentUserVariants: Record<string, MockUserFull> = {
  none: {
    id: 'none',
    user_name: '',
    full_name: 'No user',
    email: '',
    user_roles: [],
    user_sites: [],
    studies: [],
    user_settings: [],
  },
  dev: {
    id: 'c17a04bc-3e22-4ae2-bbc4-d6cf588f5be6',
    user_name: 'sbushko',
    full_name: 'Stanislav Bushko',
    email: 'sbushko@namsa.com',
    user_roles: [],
    user_sites: [],
    studies: [
      {
        ID: 69,
        Name: 'Dev Study',
        Description: 'Study for devs to work within the test env',
        Alias: 'store69',
        SyncronyVersion: 2,
        Roles: [
          {
            ID: 197,
            Name: 'Investigator',
            Description: 'Investigator',
            JsonPermissions:
              '{ "answerQuery": 1, "canAccessNavBar": 1, "canAccessSidePanel": 1, "canAccessSidebar": 1, "canEPro": 1, "createFormData": 1, "createSubject": 1, "deleteForm": 1, "missingOff": 1, "missingOn": 1, "naOff": 1, "naOn": 1, "print": 1, "auditTrail_access": 1, "readEnrollmentBySite": 1, "readFormData": 1, "readQuery": 1, "readSite": 1, "readSubject": 1, "readVASScores": 1, "reporting": 1, "restoreForm": 1, "signForm": 1, "signOff": 1, "signOn": 1, "updateFormData": 1, "updateSubject": 1, "viewDeletedSubForms": 1 }',
            StudyID: 69,
          },
        ],
        Sites: [
          {
            ID: 520,
            RegionID: 41,
            Name: 'Default Site',
            Description: 'Default Site',
            SiteNumber: 1,
            Inactive: false,
            StudyID: 69,
          },
        ],
      },
    ],
    user_settings: [
      {
        UserID: 'c17a04bc-3e22-4ae2-bbc4-d6cf588f5be6',
        Name: 'DefaultStudy',
        StudyID: 0,
        Value: '69',
      },
      {
        UserID: 'c17a04bc-3e22-4ae2-bbc4-d6cf588f5be6',
        Name: 'DefaultRole',
        StudyID: 69,
        Value: '204',
      },
    ],
  },
  guest: {
    id: 'user2',
    user_name: 'jdoe',
    full_name: 'John Doe',
    email: 'jdoe@example.com',
    user_roles: [],
    user_sites: [],
    studies: [],
    user_settings: [],
  },
};
